export default __webpack_public_path__ + "static/media/trapezoid.0d8b7f1f.webp";